import { useEffect } from 'react';
import Suspenseloader from '../../common/splash/suspenseloader';

import { useAuthContext } from 'src/auth/AuthProvider';
import { useHistory } from 'react-router-dom';
import { deleteCookie, getCookie } from 'src/utils/cookie';
import { CookieredirectUrl } from 'src/utils/constants';

export function LoginFromCookie() {
  const { handleStoredLogin } = useAuthContext();
  const { push } = useHistory();

  useEffect(() => {
    let active = true;
    const login = async () => {
      const succeeded = await handleStoredLogin(true);
      if (!active) {
        return;
      }
      if (!succeeded) {
        push('/login');
        return;
      }
      const redirectURL = getCookie(CookieredirectUrl);
      if (redirectURL) {
        push(redirectURL);
        deleteCookie(CookieredirectUrl);
      } else {
        push('/');
      }
    };

    login();
    return () => {
      active = false;
    };
  }, [handleStoredLogin, push]);

  return <Suspenseloader />;
}
